module.exports = "<div id=\"overall-question-component\">\n<p>\n  Are you Sure?\n</p>\n<button mat-raised-button mat-dialog-close>Cancel</button>\n<button class=\"primary-btn\" mat-raised-button [mat-dialog-close]=\"true\">Yes</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/mmam/angular/src/app/are-you-sure/are-you-sure.component.html
// module id = ../../../../../src/app/are-you-sure/are-you-sure.component.html
// module chunks = main